import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglemapsComponent } from './simple-icons-googlemaps.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglemapsComponent ],
    exports:      [ SimpleIconsGooglemapsComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglemapsModule {}
